import React, { Component } from "react";

import LandingPage from "./LandingPage/LandingPage";
import InitialForm from "./InitialForm/InitialForm";
import "../assets/styles/style.css";
import apiService from "./Services/APIService";
import HWUser from "./HWLibrary/HWUser";
import "react-block-ui/style.css";
import closeImg from "../images/close-icon.png";
import xmppService from "./Services/XMPPService";
import HWLog from "./HWLibrary/HWLog";
import ConversationPage from "./Conversation/ConversationPage";
import StartUp from "./StartUp";
import { s360ConfigService } from "./Services/S360Config";
import ActivityIndicator from "./CommonUtils/ActivityIndicator";
import PopUpMessage from "./CommonUtils/PopUpMessage";
import { sendOnAppOpen, sendOnAppClose } from "./Services/HWIframeBridge";
class Simplify360Chat extends Component {
  constructor(props) {
    super(props);
    const isLoggedIn = HWUser.isLoggedIn();
    HWLog.info("Is Logged In: " + isLoggedIn);
    this.timer = 0;
    const showForm = s360ConfigService?.config?.configDetails?.showForm;
    let firstPage =
      !isLoggedIn && showForm
        ? Simplify360Chat.pageName.initialForm
        : Simplify360Chat.pageName.landingPage;
    firstPage = s360ConfigService?.config?.configDetails?.offline
      ? "offlinePage"
      : firstPage;
    let showActivityIndicator = isLoggedIn ? false : !(!isLoggedIn && showForm);
    this.state = {
      visiblePage: firstPage,
      isAppOpen: false,
      showForm: showForm,
      showPopUpMessage: false,
      showActivityIndicator: showActivityIndicator,
      goback: false,
      isVisible: false,
      timer: 0,
      text: "",
      isActive: false,
    };
  }

  static pageName = {
    // enum
    initialForm: "initialForm",
    landingPage: "landingPage",
    conversationPage: "conversationPage",
    offlinePage: "offlinePage",
  };
 
  render() {
    HWLog.info("MAIN PAGE RENDER");
    let isLoggedIn = HWUser.isLoggedIn();
    return (
      <>
        {<StartUp actions={this.actions} />}
        {this.state.isAppOpen && (
          <div
            className="s360-main-float-container"
            id="container"
            style={this.containerStyle()}
          >
            {this.state.visiblePage ===
              Simplify360Chat.pageName.offlinePage && (
              <InitialForm
                key={"inital-form-" + false}
                config={s360ConfigService.config}
                actions={this.actions}
                {...this.state}
              />
            )}
            {this.state.visiblePage ===
              Simplify360Chat.pageName.initialForm && (
              <InitialForm
                key={"inital-form-" + isLoggedIn}
                config={s360ConfigService.config}
                actions={this.actions}
                {...this.state}
                errorMessage={this.state.popUpMessage}
              />
            )}
            {this.state.visiblePage ===
              Simplify360Chat.pageName.landingPage && (
              <LandingPage
                key={"landing-page-" + isLoggedIn}
                config={s360ConfigService.config}
                actions={this.actions}
                {...this.state}
                isActive={this.isActiveCallback}
              />
            )}
            {this.state.visiblePage ===
              Simplify360Chat.pageName.conversationPage && (
              <ConversationPage
                key={"conversation-page-" + isLoggedIn}
                config={s360ConfigService.config}
                actions={this.actions}
                {...this.state}
              />
            )}
            {this.state.showActivityIndicator && (
              <ActivityIndicator
                config={s360ConfigService.config}
                actions={this.actions}
                {...this.state}
              />
            )}
            {this.state.showPopUpMessage && (
              <PopUpMessage
                popUpMessage={this.state.popUpMessage}
                onClose={this.state.closeAction}
              />
            )}
          </div>
        )}
        {!HWUser.isLoggedIn() && this.state.isVisible && !this.state.isAppOpen && (
          <div
            id="s360-popup-float-message-container-id"
            class="s360-popup-float-message-container s360-hidden"
          >
            <div class="s360-popup-float-img">
              <img
                src={closeImg}
                height="8px"
                width="8px"
                float="right"
                style={{ marginBottom: "4px", marginLeft: "128px",cursor:'pointer' }}
                id="s360-popup-float-img-id"
                onClick={this.handleClose}
                
              ></img>
            </div>
            <span
              id="s360-popup-float-message-id"
              class="s360-popup-float-message"
            >
              {this.state.text}
            </span>
          </div>
        )}
      </>
    );
  }

  componentDidMount() {
    console.log(s360ConfigService.config.autoPopup,"CONFIG CHECK");
    if(s360ConfigService.config.autoPopup){
    let intervalId;
    
      intervalId = setInterval(() => {this.onStartUpClick()
      clearInterval(intervalId)},s360ConfigService.config.autoPopup)
      }

    if (this.state.isAppOpen) {
      this.checkAndAutoLogin();
    }

    if (!HWUser?.isLoggedIn()) {
      this.startTimer();
    }
  }

  handleClose = () => {
    this.setState({ isVisible: false });
    

   if(window.innerWidth < 500 && s360ConfigService.timerMessages.length>0) 
   { window.parent.postMessage(
      {
        iframeMinimized:'true'
      },
      "*"
    )}

  };

  isActiveConversation = () => {
    let isClosed =
      (this.state.activeConversation &&
        this.state.activeConversation.active != null &&
        this.state.activeConversation.active !== undefined &&
        this.state.activeConversation.active === false) ||
      !this.state.activeChatSession;

    return !isClosed;
  };

  startTimer = () => {
    if(s360ConfigService?.config?.popupMessage?.length >0){
     
      s360ConfigService?.config?.popupMessage.sort(
        (a, b) => this.getTimeInSec(a.time) - this.getTimeInSec(b.time)
      );
      console.log("arr", s360ConfigService.config.popupMessage);
      this.timer = setInterval(this.countIncrease, 1000);
  
      console.log("int..", s360ConfigService.config.popupMessage.at(-1).time);
      let lap = s360ConfigService?.config?.popupMessage?.at(-1)?.time;
      if(lap !== undefined){
        if (  this.getTimeInSec(lap) < this.state.timer) {
          clearInterval(this.timer);
        }
      }
    }
    
   
  };

  getTimeInSec = (time) => {
    if(time!== undefined)
   { const [hours, minutes, seconds] = time.toString().split(":");
    let totalSeconds = +hours * 60 * 60 + +minutes * 60 + +seconds;
    return totalSeconds;}
  };
  countIncrease = () => {
    let interval = this.state.timer + 1;
    this.setState({ timer: interval });
    //  console.log("time",interval);
    let lap = s360ConfigService.config.popupMessage.at(-1).time;
    if(lap !== undefined){
      if (
        this.isActiveConversation() ||
        this.getTimeInSec(lap) < this.state.timer
      ) {
        clearInterval(this.timer);
        this.setState({ isVisible: false });
      }
    }
    

    let msg = s360ConfigService.config.popupMessage.find(
      ({ time }) => this.getTimeInSec(time) === interval
    );

    //for popup effect only..
    let check = s360ConfigService.config.popupMessage.find(
      ({ time }) => this.getTimeInSec(time) === interval + 1
    );
    if (check != undefined) {
      this.setState({ isVisible: false });
    }

    //To display message
    if (msg != undefined) {
      let text = msg.text;
      if(window.innerWidth < 500 && s360ConfigService.timerMessages.length>0) 
     { window.parent.postMessage(
        {
          iframeMinimizedandPopup:'true'
        },
        "*"
      )}
      this.setState({ text: text, isVisible: true });

    }
  };

  actions = {
    startChat: (formDetails) => {
      this.login(formDetails);
    },
    startConversation: (details, completionHandler) => {
      this.startConversation(details, completionHandler);
    },
    showLandingScreen: () => {
      this.moveToPage(Simplify360Chat.pageName.landingPage);
    },
    onStartUpClick: () => {
      this.onStartUpClick();
    },
    markActiveConversationAsClosed: () => {
      this.markActiveConversationAsClosed();
    },
    onHideChatWindow: () => {
      this.setState({ isAppOpen: false });
    },
    showPopUpMessage: (message) => {
      this.showPopUpMessage(message);
    },
    submitForm: (contactFormDetails) => {
      this.submitForm(contactFormDetails);
    },
    showPopUpMessageAction: (message) => {
      this.showPopUpMessageAction(message);
    },
    closePopup: () => {
      this.closePopup();
    },
  };

  checkAndAutoLogin = () => {
    console.log("qaw");
    s360ConfigService.loadClientConfigFromToken();
    if (
      !HWUser.isLoggedIn() &&
      s360ConfigService.config.configDetails?.showForm === false &&
      this.state.isAppOpen
    ) {
      // Auto Login
      let configFormDetails = { ...s360ConfigService.s360UserConfig };

      this.login(configFormDetails);

      // alert("AUTO LOGIN");
    }
  };

  onStartUpClick = () => {
    
     
    let updatedState = !this.state.isAppOpen;
    console.log("isAppOpen", this.state.isAppOpen);
    if (updatedState) {
      sendOnAppOpen();
    } else {
      sendOnAppClose();
    }
    this.setState({ isAppOpen: updatedState }, () => {
      this.checkAndAutoLogin();
    });
    localStorage.removeItem("finalvalue");
  };

  login = (formDetails) => {
    return apiService
      .logInWithFormData(formDetails)
      .then((loginResult) => {
        HWLog.info("LOGIN Result: ", loginResult.data);
        if (!loginResult.data || loginResult.data.error) {
          this.setState({ errorMessage: loginResult.data.error || "" }, () => {
            this.showPopUpMessage(
              loginResult.data.error ||
                "Something went worng. Please try again."
            );
          });
        } else {
          HWUser.updateUserDetails(loginResult.data);
          this.setState({ showActivityIndicator: false }, () => {
            this.moveToPage(Simplify360Chat.pageName.landingPage); // XMPP connection is handled on landing screen.
          });
        }
      })
      .catch(this.onAPIError);
  };

  markActiveConversationAsClosed = () => {
    if (this.state.activeConversation) {
      let activeConversation = this.state.activeConversation;
      activeConversation.active = false;
      HWLog.info("MARKED ACTIVE CONVERSATION AS CLOSED:");
    }
  };

  showPopUpMessage = (message) => {
    if (!message) {
      return;
    }
    this.setState({
      showPopUpMessage: true,
      popUpMessage: message,
      showActivityIndicator: false,
      closeAction: this.closePopup,
    });
  };
  //handle error here from text boc and scroll and pass value here

  showPopUpMessageAction = (message) => {
    if (!message) {
      return;
    }
    this.setState({
      showPopUpMessage: true,
      popUpMessage: message,
      showActivityIndicator: false,
      closeAction: this.goToHome,
    });
  };

  // Moves to existing conversation.
  startConversation = (conversationDetials, completionHandler) => {
    this.setState(
      { activeConversation: conversationDetials, isActive: true },
      () => {
        clearInterval(this.timer);
        console.log("id", this.state.activeConversation.sessionId);
        xmppService
          .sendUserMetaData(
            s360ConfigService.userData,
            this.state.activeConversation.sessionId
          )
          .catch((error) => {
            console.log("couldn't send user meta data");
          });
        this.moveToPage(
          Simplify360Chat.pageName.conversationPage,
          completionHandler
        );
      }
    );
    console.log("start");
  };

  moveToPage = (pageName, onStateUpdate) => {
    this.setState({ visiblePage: pageName }, () => {
      onStateUpdate && onStateUpdate();
    });
  };

  configureAndConnectToXMPP = (xmpppConfig) => {
    xmppService.configure(xmpppConfig).catch(this.onAPIError);
  };

  onAPIError = (error) => {
    let messageToShow =
      error && error.message === "Network Error"
        ? "Please check your internet connectivity."
        : "Could not connect to server, please try again.";
    // HWLog.error(error, messageToShow);
    console.log("error:", error);
    console.log("ms:", error.Message);
    this.showPopUpMessage(messageToShow);
    // alert("Could not connect to the server. Please try again.");
  };

  containerStyle = () => {
    return {
      background:
        s360ConfigService.config.designDetails.headerBackgroundImage !==
          undefined &&
        s360ConfigService.config.designDetails.headerBackgroundImage !== ""
          ? "url(" +
            s360ConfigService.config.designDetails.headerBackgroundImage +
            ")"
          : s360ConfigService.config.designDetails.headerColor,
      borderColor: s360ConfigService.config.designDetails.headerColor,
      borderStyle: "none",
      borderWidth: "0.5px",
      borderRadius: "10px",
      // height:"640px",
      // width:"360px"
    };
  };

  submitForm = (contactFormDetails, func) => {
    return apiService
      .createTicketWithFormData(contactFormDetails)
      .then((result) => {
        HWLog.info("Contact form result: ", result.data);
        if (!result.data || result.data.error) {
          this.setState({ errorMessage: result.data.error || "" }, () => {
            this.showPopUpMessageAction(
              result.data.error || "Something went worng. Please try again."
            );
          });
        } else {
          this.showPopUpMessageAction("Form submitted successfully");
        }
      })
      .catch(this.onAPIError);
  };

  goToHome = () => {
    this.setState({
      showPopUpMessage: false,
      popUpMessage: null,
      goback: true,
    });
  };

  closePopup = () => {
    this.setState({ showPopUpMessage: false, popUpMessage: null });
  };
}

export default Simplify360Chat;
